import React, { useState, useEffect } from 'react';
import axios from 'axios';

const IPDisplay = () => {
  const [ip, setIp] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get('https://csc.iitd.ac.in/backend/get_ip.php');
        // Ensure the response data is properly handled
        if (response.data && response.data.ip) {
          setIp(response.data.ip);
        } else if (typeof response.data === 'string') {
          setIp(response.data);
        } else {
          throw new Error('Invalid IP data format');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch IP');
      } finally {
        setLoading(false);
      }
    };

    fetchIP();
  }, []);

  if (loading) return <div>Loading IP address...</div>;
  if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;

  return (
    <div style={{ 
      padding: '20px',
      textAlign: 'center',
      fontSize: '1.2rem'
    }}>
      <h2>Your Network IP</h2>
      <p style={{ 
        fontSize: '1.5rem',
        fontWeight: 'bold',
        margin: '10px 0'
      }}>
        {ip || 'Not available'}
      </p>
      {ip && ip.startsWith('10.') ? (
        <p style={{ color: 'green' }}>Internal IITD Network</p>
      ) : ip ? (
        <p style={{ color: 'red' }}>Non-IITD Network User</p>
      ) : null}
    </div>
  );
};

export default IPDisplay;